import React from "react";
import { useTranslation } from "react-i18next";

const SecurityAccessDenied = (): JSX.Element => {
	const { t } = useTranslation();
	return <div className="alert alert-danger">{t("lib:go_security.field.no_access")}</div>;
};

export default SecurityAccessDenied;
